import { useMoviesType, useVerifiedOfferBin, useVerifiedUnipalOffer } from '../state';

import { setCookie } from 'cookies-next';
import shallow from 'zustand/shallow';
import { useCity } from './use-city';
import { useEffect } from 'react';

export const useStateObserver = (): void => {
  const { cityId } = useCity();
  const [
    verifiedOfferBin,
    verifiedOfferLast4Bin,
    verifiedExpiryMonth,
    verifiedExpiryYear,
  ] = useVerifiedOfferBin(
    s => [
      s.verifiedOfferBin,
      s.verifiedOfferLast4Bin,
      s.verifiedExpiryMonth,
      s.verifiedExpiryYear,
    ],
    shallow
  );
  const [verifiedUnipalOffer] = useVerifiedUnipalOffer(
    s => [s.verifiedUnipalOffer],
    shallow
  );
  const moviesType = useMoviesType(s => s.moviesType, shallow);

  /* Setting a cookie with the cityId. */
  useEffect(() => {
    setCookie('city', cityId);
  }, [cityId]);

  /* Setting a cookie with bank offer (bin number and last4 bin number). */
  useEffect(() => {
    if (
      verifiedOfferBin &&
      verifiedOfferLast4Bin &&
      verifiedExpiryMonth &&
      verifiedExpiryYear
    ) {
      setCookie('bankOfferDataBin', verifiedOfferBin);
      setCookie('bankOfferDataLast4', verifiedOfferLast4Bin);
      setCookie('bankOfferDataExpiryMonth', verifiedExpiryMonth);
      setCookie('bankOfferDataExpiryYear', verifiedExpiryYear);
    } else if (verifiedUnipalOffer?.unipalStudentId) {
      setCookie('unipalStudentId', verifiedUnipalOffer?.unipalStudentId);
    } else {
      setCookie('bankOfferDataBin', '');
      setCookie('bankOfferDataLast4', '');
      setCookie('bankOfferDataExpiryMonth', '');
      setCookie('bankOfferDataExpiryYear', '');
      setCookie('unipalStudentId', '');
    }
  }, [
    verifiedExpiryMonth,
    verifiedExpiryYear,
    verifiedOfferBin,
    verifiedOfferLast4Bin,
    verifiedUnipalOffer?.unipalStudentId,
  ]);

  /* Setting a cookie with home page movies type filter */
  useEffect(() => {
    setCookie('moviesType', moviesType);
  }, [moviesType]);
};
